module.exports = __webpack_public_path__ + "static/img/2.e0a5021.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/eng/2.png
// module id = QFO8
// module chunks = 0